import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useTopRetailers } from "@faire/retailer-visitor-shared/views/product/ProductDetails/__internal__/TopRetailers/useTopRetailers";
import { getCurrentPath } from "@faire/web--source/common/Path";
import { Accordion } from "@faire/web--source/slate/Accordion";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout/Column";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
export var TopRetailers = function(param) {
    var productToken = param.productToken;
    var _useTopRetailers = useTopRetailers({
        productToken: productToken
    }), online_retailers = _useTopRetailers.online_retailers, brick_and_mortar_retailers = _useTopRetailers.brick_and_mortar_retailers;
    if (!online_retailers.length && !brick_and_mortar_retailers.length) {
        return null;
    }
    var items = brick_and_mortar_retailers.filter(function(retailer) {
        return retailer.address && retailer.address.full_formatted_address;
    }).map(function(retailer) {
        var _retailer_address, _retailer_address1, _retailer_address2, _retailer_address3, _retailer_address4;
        var _retailer_address_full_formatted_address;
        return {
            question: /*#__PURE__*/ _jsxs(Typography, {
                variant: "paragraphSansRegular",
                children: [
                    /*#__PURE__*/ _jsx("b", {
                        children: retailer.name
                    }),
                    ((_retailer_address = retailer.address) === null || _retailer_address === void 0 ? void 0 : _retailer_address.city) && ((_retailer_address1 = retailer.address) === null || _retailer_address1 === void 0 ? void 0 : _retailer_address1.state) ? " in ".concat((_retailer_address2 = retailer.address) === null || _retailer_address2 === void 0 ? void 0 : _retailer_address2.city, ", ").concat((_retailer_address3 = retailer.address) === null || _retailer_address3 === void 0 ? void 0 : _retailer_address3.state) : ""
                ]
            }),
            answer: /*#__PURE__*/ _jsx("iframe", {
                src: "https://maps.google.com/maps?output=embed&q=".concat(encodeURIComponent((_retailer_address_full_formatted_address = (_retailer_address4 = retailer.address) === null || _retailer_address4 === void 0 ? void 0 : _retailer_address4.full_formatted_address) !== null && _retailer_address_full_formatted_address !== void 0 ? _retailer_address_full_formatted_address : "")),
                width: "100%",
                height: "300px",
                style: {
                    border: 0
                },
                allowFullScreen: true,
                loading: "lazy",
                referrerPolicy: "no-referrer-when-downgrade"
            })
        };
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            online_retailers.length > 0 ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "pageHeaderSerifRegular",
                        children: "Shop Trusted Retailers"
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "1x"
                    }),
                    /*#__PURE__*/ _jsx(Column, {
                        gap: "1x",
                        children: online_retailers.slice(0, 3).map(function(retailer, i) {
                            return /*#__PURE__*/ _jsx(Button, {
                                variant: "primary",
                                linkTo: getCurrentPath().append({
                                    consumerModeRedirect: retailer.website_url
                                }).toString(),
                                children: retailer.name
                            }, i);
                        })
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "3x"
                    })
                ]
            }) : null,
            items.length > 0 ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "pageHeaderSerifRegular",
                        style: {
                            marginBottom: getSpacing("-2x")
                        },
                        children: "Rather shop in person?"
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "1x"
                    }),
                    /*#__PURE__*/ _jsx(Accordion, {
                        items: items,
                        initiallyOpenIndex: 0,
                        title: ""
                    })
                ]
            }) : null
        ]
    });
};
